import { useTranslation } from 'react-i18next'

import { Globe } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Chip } from '@reveni-io/reveni-ui'

const InternationalChip = () => {
  const theme = useTheme()
  const { t } = useTranslation()

  return <Chip label={t('Internacional')} Icon={Globe} backgroundColor={theme.colors.ai.surface} />
}

export default InternationalChip
